// extracted by mini-css-extract-plugin
export default {"button":"Common_button__Mbfzs"};